import { datadogLogs, LogsInitConfiguration } from '@datadog/browser-logs';
import { datadogRum, RumInitConfiguration } from '@datadog/browser-rum';

const {
  VITE_DATADOG_APP_ID,
  VITE_DATADOG_CLIENT_TOKEN,
  VITE_DATADOG_ENV
} = import.meta.env

let isDataDogInitialised = false

function initDataDog() {
  if (isDataDogInitialised || !VITE_DATADOG_APP_ID || !VITE_DATADOG_CLIENT_TOKEN || !VITE_DATADOG_ENV) {
    return;
  }

  const baseConfig = {
    env: VITE_DATADOG_ENV,
    clientToken: VITE_DATADOG_CLIENT_TOKEN,
    site: 'datadoghq.eu',
    sessionSampleRate: 100
  } as const
  
  datadogRum.init({
    ...baseConfig as RumInitConfiguration,
    applicationId: VITE_DATADOG_APP_ID,
    service: 'portal',
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: 'mask',
  })

  datadogLogs.init({
    ...baseConfig as LogsInitConfiguration,
    forwardErrorsToLogs: true
  })

  isDataDogInitialised = true
}

initDataDog()